import List from "../List/List";
import Layout from "../layout/Layout";
import { RouteComponentProps } from "@reach/router";
import { useParams } from 'react-router-dom';
import InventoryLandingView from "./InventoryLandingView";
import { EntityViewTypes } from "../../../enums/EntityViewTypes";
import GetSchema from "../entityComponents/Schema";
import { EntityNames } from "../../../enums/EntityNames";

export default function InventoryPage(props: RouteComponentProps) {
    const { entityName } = useParams();
    const schema = entityName ? GetSchema(entityName) : undefined;
    return (
        <Layout entityName={entityName!} data={undefined} pageTitle={schema ? `Browse ${schema.displayName}` : `Browse inventory`} showBackButton={entityName ? true : false} showBreadcrumb={false} canScroll={false}>
            {!entityName && <InventoryLandingView />}
            {entityName && <List parentEntityName={undefined} entityId={''} entityName={entityName} enableFilters={true} searchType={EntityViewTypes.search} canAdd={false} tabView={false} alwaysShowheader={entityName === EntityNames.containers} />}
        </Layout>
    )
}